





<div id="profile" [ngClass]="{'active': show, 'idle': !show}" style="text-align: center;">
  <div class="profile-container" >
    <!-- En-tête avec photo de profil -->
    <div class="profile-header">
      <div class="profile-card">
        <img [src]="profilePhotoUrl || 'https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c'"  alt="Profile Picture" class="profile-pic" />
        <button mat-icon-button class="microphone-btn camera-button" (click)="fileInput.click()">
          <mat-icon>camera_alt</mat-icon>
        </button>
        
        <input type="file" #fileInput (change)="onChangeProfilePhoto($event)" hidden>
      </div>
      <h2 class="profile-title">Profile</h2>
    </div>
  
    <!-- Formulaire -->
    <form [formGroup]="profileForm" class="profile-form">
      <!-- Nom -->
      <div class="form-row">
        <button mat-icon-button class="microphone-btn " (click)="togglePlayback('name')" [disabled]="!audioURLs['name']">
          <mat-icon>{{ isPlaying['name'] ? 'stop' : 'play_arrow' }}</mat-icon>
        </button>
        <div class="input-container">
          <label>Nom et Prénom</label>
          <input #nameInput [ngClass]="{'error': showError && !nameInput.value}"
            type="text"
            formControlName="name"
            placeholder="Nom et Prénom"
            class="input-field"
          />
          <p *ngIf="showError && !nameInput.value" class="error-message">Veuillez entrer votre nom et prénom.</p>
          
        </div>
        <mat-icon *ngIf="isFieldValid('name')" class="success-icon">check_circle</mat-icon>
        <button mat-icon-button class="microphone-btn" (click)="toggleRecording('name')">
          <mat-icon>{{ recordingStates['name'] ? 'stop' : 'mic' }}</mat-icon>
        </button>
      </div>
      
      <!-- Profession -->
      <div  class="form-row">
        <button mat-icon-button class="microphone-btn" (click)="togglePlayback('profession')" [disabled]="!audioURLs['profession']">
          <mat-icon>{{ isPlaying['profession'] ? 'stop' : 'play_arrow' }}</mat-icon>
        </button>
        <div class="input-container">
          <label>Profession</label>
          <input #descriptionInput placeholder="Profession"
            [ngClass]="{'error': showError && !descriptionInput.value}"
            type="text"
            formControlName="profession"
            placeholder="Enter votre profession"
            class="input-field"
          />
          <p *ngIf="showError && !descriptionInput.value" class="error-message">Veuillez entrer votre profession.</p>
          
        </div>
        <mat-icon *ngIf="isFieldValid('profession')" class="success-icon">check_circle</mat-icon>
        <button mat-icon-button class="microphone-btn" (click)="toggleRecording('profession')">
          <mat-icon>{{ recordingStates['profession'] ? 'stop' : 'mic' }}</mat-icon>
        </button>
      </div>
  
      <!-- Ville -->
      <div class="form-row">
        <button mat-icon-button class="microphone-btn" (click)="togglePlayback('city')" [disabled]="!audioURLs['city']">
          <mat-icon>{{ isPlaying['city'] ? 'stop' : 'play_arrow' }}</mat-icon>
        </button>
        <div class="input-container">
          <label>Ville</label>
          <input #villeInput placeholder="Ville" 
            [ngClass]="{'error': showError && !villeInput.value}"
            type="text"
            formControlName="city"
            class="input-field"
          />
          <p *ngIf="showError && !villeInput.value" class="error-message">Veuillez entrer votre ville.</p>
          
        </div>
        <mat-icon *ngIf="isFieldValid('city')" class="success-icon">check_circle</mat-icon>
        <button mat-icon-button class="microphone-btn" (click)="toggleRecording('city')">
          <mat-icon>{{ recordingStates['city'] ? 'stop' : 'mic' }}</mat-icon>
        </button>
      </div>
    </form>
  
    <!-- Bouton de validation -->
    <button (click)="onContinueClick(nameInput, villeInput, descriptionInput)"
      mat-fab
     
      [disabled]="!profileForm.valid"
      class="validate-button"
      (click)="onSubmit()"
    >
      <mat-icon>check</mat-icon>
    </button>

  </div>
</div>
